import repository from "../Repository";

export default {
  async registerStudents(studentList, screenId) {
    const res = await repository.post(
      `student_upload`,
      { student_list: studentList },
      {
        headers: { s: screenId }
      }
    );
    return res;
  }
};
